// LEGACY UI: replace with Field with InputGroup from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).

import FormError from "@casino/legacyUi/form/FormError";
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
  type RegisterOptions,
} from "react-hook-form";
import useFormPhoneNumber from "./hooks/useFormPhoneNumber";
import PhoneFields from "./PhoneFields";

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  error?: string;
  value?: string;
  rules?: RegisterOptions;
  required?: boolean;
  label?: string;
  excludedCountries?: string[];
};

const FormPhoneNumber = <T extends FieldValues>({
  name,
  control,
  error,
  value,
  required = false,
  label,
  excludedCountries,
}: Props<T>) => {
  const { validatePhoneNumber } = useFormPhoneNumber(
    required,
    excludedCountries,
  );
  return (
    <Controller
      control={control}
      name={name}
      rules={{
        required: required && "errors.input.required",
        validate: (phone) => validatePhoneNumber(phone as string),
      }}
      render={({ field }) => {
        const handleChange = field.onChange;
        return (
          <div>
            <PhoneFields
              value={value ?? ""}
              onChange={handleChange}
              error={error}
              label={label}
              excludedCountries={excludedCountries}
            />
            <FormError
              message={error ?? ""}
              data-testid={`${name}-form-error`}
            />
          </div>
        );
      }}
    />
  );
};

export default FormPhoneNumber;
